import { h } from 'vue'

export function getHighlightTextVNode (text, highlightStrPos) {
  const children = []

  let lastPos = 0
  highlightStrPos.forEach(([startPos, endPos]) => {
    children.push(h('span', {}, text.slice(lastPos, startPos)))
    children.push(h('span', { className: 'new-version-important-text' }, text.slice(startPos, endPos)))
    lastPos = endPos
  })

  children.push(h('span', {}, text.slice(lastPos)))

  return h('span', {}, children)
}
